import axios from "axios";
import { API_URL } from "../config/endpoints";

export function login(formData) {
    return new Promise((resolve, reject) => {
        axios
            .post(`${API_URL}api/login`, formData)
            .then(async (response) => {
                resolve(response.data);
            })
            .catch((err) => {
                reject(err);
            });
    });
}

export function signUp(formData) {
    return new Promise((resolve, reject) => {
        axios
            .post(`${API_URL}api/register`, formData)
            .then(async (response) => {
                resolve(response.data);
            })
            .catch((err) => {
                reject(err);
            });
    });
};
export function updateSignup (formdata){
    return new Promise((resolve,reject)=>{
        axios
        .put(`${API_URL}api/updateSignup`,formdata)
        .then(async(response)=>{
            resolve(response);
        }).catch((error)=>
        {
            reject(error);
        });
    });
};
export function getUserData(data){
    return new Promise ((resolve,reject)=>{
        axios.post(`${API_URL}api/userData`,data)
        .then((response)=>{
            resolve(response)
        }).catch((error)=>{
            reject(error)
        })
    })
}